const normalizeType = (item) =>
    String(item?.marketplace_type || item?.type || item?.marketplace || '').toLowerCase();

export const getOzonAccounts = (marketplaces) =>
    marketplaces.filter((item) => normalizeType(item).includes('ozon'));

export const getOzonProjects = (workspaces, ozonAccounts) => {
    const ozonAccountIds = new Set(ozonAccounts.map((account) => account.id));
    const linkedProjects = workspaces.filter(
        (workspace) =>
            workspace.cabinets &&
            workspace.cabinets.some((cabinet) =>
                ozonAccountIds.has(cabinet.marketplace_account_id)
            )
    );

    if (linkedProjects.length > 0) {
        return linkedProjects;
    }

    return workspaces;
};

export const getOzonProjectCabinets = (ozonProjectId, ozonProjects, ozonAccounts) => {
    if (!ozonProjectId) return [];
    const project = ozonProjects.find((item) => item.id === ozonProjectId);
    if (!project) return [];
    const ozonAccountIds = new Set(ozonAccounts.map((account) => account.id));
    const linkedAccounts = (project.cabinets || [])
        .filter((cabinet) => ozonAccountIds.has(cabinet.marketplace_account_id))
        .map((cabinet) => ozonAccounts.find((account) => account.id === cabinet.marketplace_account_id))
        .filter(Boolean);

    // Пустой проект показывает пустой список: раньше здесь был откат на «все кабинеты пользователя»,
    // из-за чего в проекте без кабинетов можно было работать (и удалить) чужой рабочий кабинет.
    return linkedAccounts;
};
